export enum EnergyType {
  LOW = 'low',
  ORIGINAL = 'original',
  HIGH = 'high',
}
